import LoginPartial from "../../partials/auth/login.partial";

export default function LoginScreen() {
  return (
    <div className="flex justify-center items-center w-full h-screen">
      <LoginPartial />
    </div>
  );
}
